import React, { useState, useEffect } from 'react';
import Sidebar from '../sidebar/sidebar';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { updateData } from '../../hooks/api/utils';
import Loader from '../../components/loader/loader';

const EditVendor = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { id, vendor } = location.state;
  const [loading, setLoading] = useState(true);
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    email: '',
    business_name: '',
    business_address: '',
    base_url: '',
    authentication: '',
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (vendor) {
      setFormData({
        first_name: vendor.first_name || '',
        last_name: vendor.last_name || '',
        email: vendor.email || '',
        business_name: vendor.business_name || '',
        business_address: vendor.business_address || '',
        base_url: vendor.base_url || '',
        authentication: vendor.authentication || '',
      });
      setLoading(false);
    }
  }, [vendor]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setErrors({});
  };

  const validate = () => {
    const newErrors = {};
    if (!formData.first_name.trim())
      newErrors.first_name = 'First name is required';
    if (!formData.last_name.trim())
      newErrors.last_name = 'Last name is required';
    if (!formData.email.trim()) newErrors.email = 'Email is required';
    if (!formData.business_name.trim())
      newErrors.business_name = 'Business name is required';
    if (!formData.base_url.trim()) newErrors.base_url = 'Base URL is required';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    const payload = {
      first_name: formData.first_name.trim(),
      last_name: formData.last_name.trim(),
      email: formData.email.trim(),
      business_name: formData.business_name.trim(),
      business_address: formData.business_address.trim(),
      base_url: formData.base_url.trim(),
      authentication: formData.authentication.trim(),
    };

    setIsSubmitting(true);
    await updateData(
      '/admin-panel/vendors/',
      id,
      setLoading,
      payload,
      navigate,
      '/vendors'
    );
    setIsSubmitting(false);
  };

  return (
 
      <div className="rightContent">
        <div className="doc_info">
          <div className="row g-4">
            <div className="col-md-12">
              <div className="padding-inner border-radius-20 bg-white">
                <h4 className="mb-4">Edit Vendor</h4>
                {loading ? (
                  <Loader />
                ) : (
                  <form onSubmit={handleSubmit}>
                    <div className="row g-4">
                      {[
                        'first_name',
                        'last_name',
                        'email',
                        'business_name',
                        'business_address',
                        'base_url',
                        'authentication',
                      ].map((field) => (
                        <div className="col-md-6" key={field}>
                          <div className="form-group">
                            <label>
                              {field
                                .replace(/_/g, ' ')
                                .replace(/\b\w/g, (c) => c.toUpperCase())}
                                {field !== 'authentication' && <span className="text-danger">*</span>}
                            </label>
                            <input
                              type="text"
                              name={field}
                              placeholder={`Enter ${field.replace(/_/g, ' ')}`}
                              value={formData[field]}
                              onChange={handleChange}
                            />
                            {errors[field] && (
                              <div className="text-danger">{errors[field]}</div>
                            )}
                          </div>
                        </div>
                      ))}
                      <div className="col-md-12">
                        <div className="d-flex gap-3 justify-content-end">
                          <NavLink to="/vendors" className="transparent_btn">
                            Cancel
                          </NavLink>
                          <button
                            type="submit"
                            className="blue_btn"
                            disabled={isSubmitting}
                          >
                            {isSubmitting ? 'Updating...' : 'Update Vendor'}
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
  );
};

export default EditVendor;
